import { render, staticRenderFns } from "./singleUpload.vue?vue&type=template&id=0070e9e0"
import script from "./singleUpload.vue?vue&type=script&lang=js"
export * from "./singleUpload.vue?vue&type=script&lang=js"
import style0 from "./singleUpload.vue?vue&type=style&index=0&id=0070e9e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports